
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as forgot_45password8lG0HEhYRIMeta } from "/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/forgot-password.vue?macro=true";
import { default as indexJCSxsCn8ZLMeta } from "/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/index.vue?macro=true";
import { default as login_45passwordlatrUu6YOhMeta } from "/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/login-password.vue?macro=true";
import { default as loginM1nvoEeZpBMeta } from "/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/login.vue?macro=true";
import { default as logout970XRep5gIMeta } from "/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/logout.vue?macro=true";
import { default as indexuUOhWXX2bIMeta } from "/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/profile/index.vue?macro=true";
import { default as security6e3bV6FvW9Meta } from "/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/profile/security.vue?macro=true";
import { default as _91code_93nZp9cIOw74Meta } from "/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/reset-password/[code].vue?macro=true";
import { default as indexSReqft3QQOMeta } from "/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/sandbox/aside/index.vue?macro=true";
import { default as indexFqkq0vC48QMeta } from "/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/sandbox/index.vue?macro=true";
export default [
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45password8lG0HEhYRIMeta || {},
    component: () => import("/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/forgot-password.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexJCSxsCn8ZLMeta || {},
    component: () => import("/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/index.vue")
  },
  {
    name: "login-password",
    path: "/login-password",
    meta: login_45passwordlatrUu6YOhMeta || {},
    component: () => import("/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/login-password.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginM1nvoEeZpBMeta || {},
    component: () => import("/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logout970XRep5gIMeta || {},
    component: () => import("/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/logout.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexuUOhWXX2bIMeta || {},
    component: () => import("/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/profile/index.vue")
  },
  {
    name: "profile-security",
    path: "/profile/security",
    meta: security6e3bV6FvW9Meta || {},
    component: () => import("/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/profile/security.vue")
  },
  {
    name: "reset-password-code",
    path: "/reset-password/:code()",
    meta: _91code_93nZp9cIOw74Meta || {},
    component: () => import("/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/reset-password/[code].vue")
  },
  {
    name: "sandbox-aside",
    path: "/sandbox/aside",
    meta: indexSReqft3QQOMeta || {},
    component: () => import("/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/sandbox/aside/index.vue")
  },
  {
    name: "sandbox",
    path: "/sandbox",
    meta: indexFqkq0vC48QMeta || {},
    component: () => import("/workd/WORKD/_LABS/nuxtTs/dashboard:client/pages/sandbox/index.vue")
  }
]